
import apiClient from './apiClient';
import { config } from '../../config/env';

interface UploadResponse {
    key: string;
}

interface ApiResponse<T> {
    success: boolean;
    data: T;
    message?: string;
}

export const imageService = {
    /**
     * Sube una sola imagen al servidor
     * @param file - Archivo de imagen a subir
     * @returns Clave/URL de la imagen subida
     */
    uploadSingle: async (file: File): Promise<string> => {
        const formData = new FormData();
        formData.append('image', file);
        formData.append('imageName', 'vehicle');

        // Ajustar cabeceras para multipart/form-data si es necesario en apiClient
        const response = await apiClient.post<ApiResponse<UploadResponse>>('/images/single', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });

        return response.data.data.key;
    },

    /**
     * Construye la URL completa de una imagen dada su clave
     */
    getImageUrl: (key: string): string => {
        if (!key) return '';
        if (key.startsWith('http')) return key;

        // Usar la misma base URL que apiClient
        return `${config.apiUrl}/api/v1/images/${key}`;
    }
};

export default imageService;
